"use client"
import IconArrowRight from "@/app/(site)/_components/Atoms/Icons/IconArrowRight"
import { useNextJsScrollRestoration } from "@/app/(site)/_utils/_hooks/useNextJsScrollRestoration"
import { getLangCode } from "@/app/(site)/_utils/misc"
import { t } from "@/translations"
import { RelatedArticles } from "@/types"
import { usePathname } from "next/navigation"
import React, { useEffect, useState } from "react"
import ButtonText from "../../../Molecules/ButtonText"
import ArticleCard from "../../../Organisms/Cards/ArticleCard"

type Props = {
    articles: RelatedArticles[] | undefined
    displayedArticlesInit?: number | undefined
    articleListinUpdate?: number | undefined
    locale: string
}

const JournalGrid: React.FC<Props> = ({
    articles,
    locale,
    displayedArticlesInit = 7, // Default value set to 7
    articleListinUpdate = 8 // Default update count set to 8
}) => {
    const langCode = getLangCode(usePathname().split("/")[1]) ?? ""

    const [showButton, setshowButton] = useState(false)
    const [articleListLength, setArticleListLength] = useState(
        articles?.length ? articles.length : 0
    )
    const [displayedArticles, setDisplayedArticles] = useState(displayedArticlesInit)

    const handleUpdateArrayIndex = () => {
        setDisplayedArticles(prevIndex => {
            const newDisplayCount = prevIndex + articleListinUpdate
            if (newDisplayCount >= articleListLength) {
                return articleListLength
            }
            return newDisplayCount
        })
    }

    useEffect(() => {
        setArticleListLength(articles?.length ? articles.length : 0)
        if (displayedArticles >= articleListLength) {
            setshowButton(false)
        } else {
            setshowButton(true)
        }
    }, [displayedArticles, articleListLength, articles])

    useNextJsScrollRestoration()

    return (
        <div className="grid w-full grid-cols-2 gap-16 md:gap-24 lg:grid-cols-3 xl:grid-cols-4">
            {articles &&
                articles
                    .slice(0, displayedArticles)
                    .map((article, index) => (
                        <ArticleCard
                            key={index}
                            index={index}
                            article={article}
                            locale={locale}
                        />
                    ))}
            {showButton && (
                <div
                    onClick={handleUpdateArrayIndex}
                    className="flex aspect-square items-center justify-center rounded-full border border-black bg-white"
                >
                    <ButtonText
                        className="flex items-center justify-center gap-8 text-main-black"
                        icon={<IconArrowRight className="color-main-black h-20 w-20" />}
                        iconPosition="right"
                        size="big"
                        weight="regular"
                    >
                        <div className="!text-12 md:!text-16">
                            {t(langCode, "Load more")}
                        </div>
                    </ButtonText>
                </div>
            )}
        </div>
    )
}

export default JournalGrid
